const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.315 18.17c.28 0 .936-.154 2.172-1.185a.806.806 0 01.699-.163c.246.058.45.23.55.463.184.433 1.757 4.286-.17 6.214a.803.803 0 01-1.01.1c-.773-.515-2.139-.876-3.323-.876-.647 0-1.182.105-1.548.298 1.035 1.413 1.327 2.556.895 3.48-.466.995-1.67 1.5-3.58 1.5s-3.115-.505-3.58-1.5c-.433-.924-.14-2.067.894-3.48-.366-.193-.9-.298-1.548-.298-1.183 0-2.55.36-3.323.876a.796.796 0 01-1.009-.1c-1.928-1.928-.355-5.78-.17-6.214A.797.797 0 018 16.8a.8.8 0 01.512.185c1.237 1.031 1.892 1.185 2.172 1.185.726 0 .782-1.66.782-2.17s-.056-2.17-.782-2.17c-.28 0-.935.153-2.172 1.184a.8.8 0 01-1.248-.299c-.185-.433-1.758-4.287.17-6.214A.798.798 0 018.443 8.4c.773.516 2.14.876 3.323.876.648 0 1.182-.105 1.548-.298-1.035-1.413-1.327-2.556-.895-3.48C12.885 4.504 14.09 4 16 4s3.114.504 3.58 1.498c.432.924.14 2.067-.895 3.48.366.193.901.298 1.548.298 1.184 0 2.55-.36 3.323-.876a.8.8 0 011.009.101c1.928 1.927.355 5.781.17 6.214A.798.798 0 0124 15.2a.801.801 0 01-.513-.186c-1.236-1.03-1.892-1.185-2.172-1.185-.726 0-.782 1.661-.782 2.171s.056 2.17.782 2.17M16 0C7.163 0 0 7.163 0 16c0 8.836 7.163 16 16 16 8.836 0 16-7.164 16-16 0-8.837-7.164-16-16-16",
  fill: "#de97ca"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.315 13.03c.65 0 1.527.406 2.685 1.37 0 0 1.6-3.733 0-5.333-.878.585-2.398 1.01-3.767 1.01-1.127 0-2.152-.288-2.634-1.01C20.266 5.867 18.667 4.8 16 4.8s-4.267 1.066-1.6 4.266c-.48.722-1.507 1.01-2.634 1.01-1.369 0-2.889-.425-3.766-1.01-1.6 1.6 0 5.333 0 5.333 1.157-.964 2.035-1.37 2.684-1.37 1.148 0 1.582 1.268 1.582 2.97 0 1.703-.434 2.97-1.582 2.97-.649 0-1.527-.406-2.684-1.37 0 0-1.6 3.734 0 5.334.877-.586 2.397-1.01 3.766-1.01 1.127 0 2.153.287 2.634 1.01-2.667 3.2-1.067 4.266 1.6 4.266s4.266-1.066 1.6-4.266c.481-.723 1.506-1.01 2.633-1.01 1.37 0 2.89.425 3.767 1.01 1.6-1.6 0-5.334 0-5.334-1.158.964-2.036 1.37-2.685 1.37-1.147 0-1.582-1.267-1.582-2.97 0-1.702.435-2.97 1.582-2.97",
  fill: "#e8b8db"
}));

const SvgSolution2 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSolution2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/solution2.9abb48a4.svg";
export { ForwardRef as ReactComponent };